/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import _times from 'lodash/times';
import _memoize from 'lodash/memoize';

// wrap the lodash functions to avoid having lodash's TS type definition from being
// exported, which can conflict with the lodash namespace if other versions are used

/* eslint-disable import/export */
export function times<T>(count: number): number[];
export function times<T>(count: number, iteratee: (index: number) => T): T[];
export function times<T>(count: number, iteratee?: (index: number) => T) {
  if (iteratee === undefined) {
    return _times(count);
  }
  return _times(count, iteratee);
}
/* eslint-enable import/export */

// eslint-disable-next-line space-before-function-paren
export function memoize<T extends (...args: any[]) => any>(
  func: T,
  resolver?: (...args: any[]) => any
): (...args: Parameters<T>) => ReturnType<T> {
  return _memoize(func, resolver);
}

export const browserTick = (callback: FrameRequestCallback) => {
  requestAnimationFrame(callback);
};
try {
    // @ts-ignore
    times.displayName = "times";
    // @ts-ignore
    times.__docgenInfo = { "description": "", "displayName": "times", "props": { "toString": { "defaultValue": null, "description": "Returns a string representation of an object.\n@param radix Specifies a radix for converting numeric values to strings. This value is only used for numbers.", "name": "toString", "required": false, "type": { "name": "(radix?: number | undefined) => string" } }, "toFixed": { "defaultValue": null, "description": "Returns a string representing a number in fixed-point notation.\n@param fractionDigits Number of digits after the decimal point. Must be in the range 0 - 20, inclusive.", "name": "toFixed", "required": true, "type": { "name": "(fractionDigits?: number | undefined) => string" } }, "toExponential": { "defaultValue": null, "description": "Returns a string containing a number represented in exponential notation.\n@param fractionDigits Number of digits after the decimal point. Must be in the range 0 - 20, inclusive.", "name": "toExponential", "required": true, "type": { "name": "(fractionDigits?: number | undefined) => string" } }, "toPrecision": { "defaultValue": null, "description": "Returns a string containing a number represented either in exponential or fixed-point notation with a specified number of digits.\n@param precision Number of significant digits. Must be in the range 1 - 21, inclusive.", "name": "toPrecision", "required": true, "type": { "name": "(precision?: number | undefined) => string" } }, "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => number" } }, "toLocaleString": { "defaultValue": null, "description": "Converts a number to a string by using the current or specified locale.\n@param locales A locale string or array of locale strings that contain one or more language or locale tags. If you include more than one locale string, list them in descending order of priority so that the first entry is the preferred locale. If you omit this parameter, the default locale of the JavaScript runtime is used.\n@param options An object that contains one or more properties that specify comparison options.", "name": "toLocaleString", "required": false, "type": { "name": "(locales?: string | string[] | undefined, options?: NumberFormatOptions | undefined) => string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/services/utils.ts#times"] = { docgenInfo: times.__docgenInfo, name: "times", path: "src/services/utils.ts#times" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    browserTick.displayName = "browserTick";
    // @ts-ignore
    browserTick.__docgenInfo = { "description": "", "displayName": "browserTick", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/services/utils.ts#browserTick"] = { docgenInfo: browserTick.__docgenInfo, name: "browserTick", path: "src/services/utils.ts#browserTick" };
}
catch (__react_docgen_typescript_loader_error) { }